import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeService {
  //setup constant values
  monthArrayId: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  monthNames: string[] = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  weekday: string[ ]= ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  
  getCurrentMonthName(){
    var d = new Date();
    var monthIs = this.monthNames[d.getMonth()];
    return monthIs
  };

  getcurrentMonthIndexId(){
    var d = new Date();
    var monthIdIs = this.monthArrayId[d.getMonth()];
    return monthIdIs
  }

  getTodaysNumber(){
    var d = new Date();
    var todaysNumberIs = d.getDate();

    return todaysNumberIs
  }

  constructor() { }
}
